"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.ORIENTATION = void 0;
var React = _interopRequireWildcard(require("react"));
var _size = require("../../styles/variables/_size");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _SeparatorModule = _interopRequireDefault(require("./Separator.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ORIENTATION = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
exports.ORIENTATION = ORIENTATION;
const Separator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    orientation = ORIENTATION.vertical,
    width,
    height
  } = _ref;
  // Dynamically compute width and height based on orientation if not provided
  const resolvedWidth = width || (orientation === ORIENTATION.vertical ? _size.size2 : 'auto');
  const resolvedHeight = height || (orientation === ORIENTATION.horizontal ? _size.size2 : 'auto');
  const style = {
    '--separator-width': resolvedWidth,
    '--separator-height': resolvedHeight
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "Separator",
    style: style,
    className: (0, _classify.default)(_SeparatorModule.default.wrapper, classNames?.wrapper)
  });
});
exports.Separator = Separator;